<div [class.pt-5]="data" class="container-transparent d-flex align-items-center">
    <ng-lottie width="300px" *ngIf="data"   [options]="optionsAnimatedSuccess" (animationCreated)="animationCreatedSuccess($event)" ></ng-lottie>
    <ng-lottie width="300px" *ngIf="!data"  [options]="optionsAnimatedFailed" (animationCreated)="animationCreatedFailed($event)" ></ng-lottie>
  </div>

    